import api from '@/lib/api/axios'
import type { ListParams, PaginatedResponse } from '@/lib/api/types'
import type { RunbookTask } from '@/types/entities'

export interface MasterRunbookTechnology {
    id?: number
    name: string
    category: string
}

export interface MasterRunbook {
    id: number
    description: string
    information: string
    tasks?: RunbookTask[]
    // AI generation inputs persisted with the runbook
    technologies?: MasterRunbookTechnology[]
    generationContext?: string
    // Auto-built detailed "RUNBOOK FOR" name, kept separate from the user-given name
    generatedName?: string
}

export const masterRunbooksApi = {
    list: (params?: ListParams) => {
        // Convert perPage to limit for backend compatibility
        const queryParams = params ? {
            ...params,
            limit: params.perPage || params.limit || 20,
            perPage: undefined,
        } : undefined
        // Remove undefined values
        if (queryParams) {
            Object.keys(queryParams).forEach(key => {
                if (queryParams[key as keyof typeof queryParams] === undefined) {
                    delete queryParams[key as keyof typeof queryParams]
                }
            })
        }
        return api.get<PaginatedResponse<MasterRunbook>>('/api/master-runbooks', { params: queryParams })
    },

    get: (id: number) =>
        api.get<MasterRunbook>(`/api/master-runbooks/${id}`),

    create: (data: Omit<MasterRunbook, 'id'>) =>
        api.post<MasterRunbook>('/api/master-runbooks', data),

    update: (id: number, data: Partial<Omit<MasterRunbook, 'id'>>) =>
        api.put<MasterRunbook>(`/api/master-runbooks/${id}`, data),

    delete: (id: number) =>
        api.delete(`/api/master-runbooks/${id}`),
}
